import { render, staticRenderFns } from "./Usidebar.vue?vue&type=template&id=69ee37c8"
import script from "./Usidebar.vue?vue&type=script&lang=js"
export * from "./Usidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports